
export const nav = {
  home: "Inicio",
  about: "Sobre Nosotros",
  events: "Eventos",
  sermons: "Sermones",
  blog: "Blog",
  contact: "Contacto",
  donate: "Donar",
  language: "Idioma"
};

export const hero = {
  title: "Entre a Adorar, Salga a servir.",
  subtitle: "Somos una iglesia cristocéntrica en Morrisville, PA, comprometida con hacer discípulos y compartir el amor de Cristo en nuestra comunidad.",
  knowUs: "Conócenos",
  watchSermons: "Ver sermones"
};

export const about = {
  title: "Acerca de Nosotros",
  location: "Morrisville, PA",
  tabs: {
    mission: "Misión",
    vision: "Visión",
    values: "Creencias",
    history: "Valores"
  },
  mission: {
    title: "Nuestra Misión",
    description: "La misión se centra en \"hacer discípulos de Jesucristo para la transformación del mundo\". Esto implica:",
    goals: {
      title: "Nuestros Objetivos:",
      proclaim: "Proclamar el Evangelio: Llevar el mensaje de salvación a todas las personas, enfatizando la necesidad de una relación personal con Jesucristo.",
      disciples: "Hacer discípulos: Educar y formar a los creyentes en la fe y ayudarlos a crecer en su vida cristiana mediante el discipulado y el apoyo mutuo.",
      spirituality: "Fomentar una espiritualidad activa y el crecimiento en la fe.",
      sacraments: "Administrar debidamente los sacramentos tal como fueron instituidos por nuestro Señor Jesucristo.",
      community: "Servir y asistir a la comunidad: Participar en actividades que ayuden a satisfacer las necesidades físicas, emocionales y espirituales de la comunidad."
    },
    quote: "Por tanto, id, y haced discípulos a todas las naciones, bautizándolos en el nombre del Padre, y del Hijo, y del Espíritu Santo.",
    reference: "Mateo 28:19"
  },
  vision: {
    title: "Nuestra Visión",
    description: "La visión de la Iglesia incluye el crecimiento espiritual y numérico, el impacto positivo en la comunidad y la unidad entre los creyentes.",
    goals: {
      title: "Nuestros Objetivos:",
      growth: "Crecimiento espiritual y numérico: Aspirar a crecer tanto en la profundización de la fe de sus miembros como en la expansión de la comunidad de creyentes.",
      impact: "Impacto en la comunidad: Promover el bienestar de la comunidad a través de obras de caridad, educación cristiana, apoyo a las familias y trabajo social.",
      unity: "Unidad entre los creyentes: Fomentar la unidad dentro del cuerpo de Cristo, promoviendo el amor hacia quienes están fuera."
    },
    commitment: "Estamos dedicados a vivir la fe de manera práctica y a llevar el amor de Cristo a todas las personas."
  },
  values: {
    title: "Nuestra Base Teológica (Creencias)",
    description: "La Iglesia sostiene creencias firmes, que tienen sus fundamentos en la Biblia, nacieron mediante la obra del Espíritu Santo, son apoyadas por la razón, han sido comprobadas a través de los años y probadas en la experiencia de un sinnúmero de creyentes.",
    subtitle: "Consideramos las siguientes creencias de un CRISTIANO:",
    beliefs: {
      god: {
        title: "a) Creer en Dios",
        content: "Creemos que hay un único Dios, verdadero Creador y Sustentador de este Universo: de infinito poder, sabiduría y bondad; padre de todos los pueblos y razas. Que revela su voluntad a través de la historia, ansía que se cumpla su propósito para cada persona y manifiesta su naturaleza en Jesucristo.",
        reference: "(Génesis 1:1; Josué 24:14-15; Hebreos 1: 1-4)"
      },
      jesus: {
        title: "b) Creer en Jesucristo",
        content: "Creemos en Jesucristo como Hijo de Dios. Que los eventos más importantes y sublimes de la historia comenzaron en un establo, continuaron en una cruz y culminaron en la tumba vacía. Que Jesucristo es el único camino para llegar a conocer a Dios y el único mediador entre Dios y los seres humanos. Que el Cristo resucitado es el Salvador de todos los seres humanos y aquellos que se unen a Él por fe, son restaurados en sus relaciones con Dios y son comisionados para servir como su pueblo reconciliador.",
        reference: "(Juan 14:6; 1 Timoteo 2:5; Hechos 10:40-43)"
      },
      holySpirit: {
        title: "c) Creer en el Espíritu Santo",
        content: "Creemos en el Espíritu Santo como la presencia viviente que obra diariamente en la vida del ser humano y cumple Su voluntad en el mundo. Que crea y renueva a la iglesia, la comunidad donde los seres humanos son reconciliados con Dios y los unos con los otros.",
        reference: "(Lucas 12:12; Gálatas 5:16-26; 6:1-10)"
      },
      church: {
        title: "d) Creer en la Iglesia",
        content: "Creemos que la Iglesia es de Dios y como sal y luz del mundo será guardada hasta el fin de los siglos. Que Dios la creó para la promoción de Su culto y la debida administración de Su Palabra y ordenanzas, para el mantenimiento de la comunión y disciplina cristianas, para la edificación de los creyentes y para testimonio al mundo.",
        reference: "(Mateo 16:18; 1 Corintios 12:28-31; 14:23-40)"
      },
      salvation: {
        title: "e) Creer en la Salvación del Pecador",
        content: "Creemos que todos los seres humanos son pecadores. Que el pecado, tanto individual como social, está sujeto al juicio divino y que la gracia de Dios en Cristo alcanza a redimir todas las áreas de la vida, cuando arrepentidos y con ánimo rectificador, nos comprometemos a hacer Su voluntad, y que es nuestro deber vincular al hombre con Cristo, a fin de que pueda ser libre del pecado y de toda influencia que pueda dañarlo o destruirlo.",
        reference: "(1 Juan 1:8; Romanos 5:20-21, 6:1-14)"
      },
      humanity: {
        title: "f) Creer en el Ser Humano",
        content: "Creemos que el ser humano es creación de Dios; quien lo creó varón y hembra, dotado de alma racional y con conocimiento, justicia y verdadera santidad. Que ante los ojos de Dios cada ser humano es de infinito valor y que todos los seres humanos son hermanos, creados a Su propia imagen, dotados para cumplir Su ley pero con posibilidad de transgredirla, según su libre albedrío. Es por ello que medimos a las instituciones humanas, cualquiera que éstas sean, por sus frutos sobre las personas.",
        reference: "(Génesis 1:27-28; Juan 11:25-27; Hechos 17:26-28)"
      },
      bible: {
        title: "g) Creer en la Biblia",
        content: "Creemos en la Biblia como el testimonio escrito, en el Antiguo y el Nuevo Testamento, de la revelación de Dios a través de hombres inspirados, en los cuales la Iglesia recibe la palabra de Dios y por medio de los cuales su fe y su obediencia se nutren. La Iglesia está segura de que Dios continuará hablando a través de las Escrituras en un mundo cambiante y en todas las formas de cultura humana.",
        reference: "(Josué 1:8; Romanos 15:4; 1 Pedro 1:23)"
      },
      kingdom: {
        title: "h) Creer en el Reino de Dios",
        content: "Creemos en el Reino de Dios como el Orden de Cosas en el cual se reconoce la soberanía de Dios, tanto teórica como prácticamente. De ahí que dondequiera que se realice la voluntad de Dios y se reconozca su soberanía, allí está el Reino de Dios.",
        reference: "(Juan 18:16-37; Lucas 17:20-25; 2 Pedro 1:10-11)"
      },
      judgment: {
        title: "i) Creer en el Juicio Divino",
        content: "Creemos que Dios es Juez de toda la tierra. Que el hombre es probado de acuerdo al uso que hace de los dones que Dios le ha confiado: tiempo, talentos y bienes materiales, y que aun cuando recibamos el perdón de Jesucristo por el mal uso de nuestra mayordomía, tendremos que responder de ella ante de Dios.",
        reference: "(Romanos 3:19; 14:12; 1 Juan 4:17)"
      },
      eternalLife: {
        title: "j) Creer en la Vida Eterna",
        content: "Creemos que, por la gracia de Dios, comenzamos a participar de la vida eterna aquí en nuestro mundo, y que la alcanzamos en su plenitud después de la muerte si hemos sido capaces de reflejar con nuestro testimonio y nuestra vida toda lo que significa la relación con Dios por medio de Jesucristo. A la muerte no le tememos, sabemos que Cristo ya la venció y que estamos en Sus manos, que nos conducirán al lugar que Él fue a preparar para nosotros.",
        reference: "(Romanos 2:6-9; 6:22-23: 1 Pedro 1:3-4)"
      },
      christianExperience: {
        title: "k) Creer en la Experiencia Cristiana",
        content: "Creemos que toda persona puede relacionarse personalmente con Dios a través de Jesucristo y que esta experiencia se produce con frecuencia en un solo instante llamado conversión, pero se repite una y otra vez en la medida en que uno tiene comunión con Cristo y en que se rinda a Él. Los que tienen esta experiencia reciben seguridad y paz.",
        reference: "(Romanos 10:9-13; 12:1-2; Juan 14:27)"
      },
      spiritTestimony: {
        title: "l) Creer en el Testimonio del Espíritu",
        content: "Creemos, que El Espíritu de Dios da testimonio a mi espíritu de que soy hijo de Dios; que Jesús me amó y se dio a sí mismo por mí; que todos mis pecados fueron borrados y que yo, aún yo, estoy reconciliado con Dios. Este testimonio es para todos los que lo aceptan.",
        reference: "(Romanos 8:16; 1 Corintios 2:12)"
      },
      christianPerfection: {
        title: "m) Creer en la Perfección Cristiana",
        content: "Cuando hablamos de \"Perfección Cristiana\", es bueno que se tenga en cuenta que no queremos decir con esto que podemos erigirnos en jueces de los demás, que nos hallamos libres de pecado y que estamos libres de tentación. Creemos en la \"Perfección Cristiana\" que se manifiesta en el amor, la buena voluntad activa hacia todos los hombres y en una vida diaria bajo el dominio de la voluntad de Dios.",
        reference: "(1 Juan 4:20-21; 1 Corintios 10:24; Efesios 5:17, 20)"
      },
      unityBelievers: {
        title: "n) Creer en la Unidad de todos los Creyentes",
        content: "Creemos en la Iglesia Universal de Jesucristo. Nos avergonzamos cuando no hacemos todo lo posible por llevar a todas las denominaciones hacia una unidad más estrecha de hermandad y acción y con regocijo apoyamos todas las fuerzas que trabajan por unir a los cristianos, pues necesitamos ser uno para que el mundo crea y para enfrentar los problemas de nuestra época.",
        reference: "(Juan 10:16 y Juan 17)"
      },
      socialTransformation: {
        title: "ñ) Creer en el Poder de Cristo para Transformar la Sociedad",
        content: "Creemos que debemos preocuparnos por la salvación personal, sin dejar a un lado nuestra responsabilidad social. Esto encuentra su basamento en el ejemplo de nuestro Señor, quien vino a servir en lugar de ser servido, quien redimió al hombre de pecado, sació su necesidad y le habilitó para reintegrarlo a la sociedad, como un ser integral. Como cristianos tenemos un ministerio que cumplir hacia aquellos que nos rodean; por tanto, todas las capacidades y cuanto posee el hombre, tiene el deber de administrarlo como instrumentos fructíferos que honren al Creador y tiene el derecho y la responsabilidad de trabajar por una sociedad en la que se cumpla para todos la amorosa voluntad de Dios.",
        reference: ""
      },
      christianLife: {
        title: "o) Vida Cristiana",
        content: "Creemos que los creyentes son llamados a la santidad, al amor al prójimo, a la justicia y a la obediencia a Cristo.",
        reference: ""
      },
      lastThings: {
        title: "p) Últimas Cosas",
        content: "Creemos en la segunda venida de Cristo, la resurrección de los muertos, el juicio final y la vida eterna.",
        reference: ""
      }
    },
    socialDeclaration: {
      title: "Nuestra Declaración de Interés Social:",
      content: "A la luz de las enseñanzas de Jesús, quien nos enseñó a amar a nuestro prójimo y a buscar la justicia para él. La iglesia reconoce su misión de predicar el Evangelio y al mismo tiempo atender las necesidades sociales y humanas de la comunidad. Promueve la dignidad, igualdad y derechos de todas las personas sin distinción. Fomenta la justicia social, la solidaridad, la ayuda a los pobres y oprimidos, y la protección de la vida y la familia. Trabaja con vocación de servicio y amor cristiano para mejorar la calidad de vida presente y futura de los individuos. Busca ser testimonio del Reino de Dios en obras concretas de amor, paz y reconciliación."
    }
  },
  history: {
    title: "Nuestros Valores",
    description: "Los valores que guían nuestra vida como iglesia y comunidad de fe:",
    values: {
      christ: {
        title: "Centralidad de Cristo",
        description: "Jesús es el centro de todo lo que somos y hacemos."
      },
      bible: {
        title: "Autoridad bíblica",
        description: "La Palabra de Dios guía nuestras creencias y prácticas."
      },
      prayer: {
        title: "Oración y dependencia del Espíritu",
        description: "Buscamos la dirección de Dios en todo."
      },
      worship: {
        title: "Adoración sincera",
        description: "Honramos a Dios con excelencia y autenticidad, en espíritu y en verdad."
      },
      discipleship: {
        title: "Discipulado intencional",
        description: "Formamos seguidores de Jesús que crecen y hacen discípulos."
      },
      evangelism: {
        title: "Evangelización y misión",
        description: "Compartimos el Evangelio local y globalmente."
      },
      service: {
        title: "Amor y servicio",
        description: "Servimos con compasión a nuestra comunidad y a los más vulnerables."
      },
      unity: {
        title: "Unidad y comunidad",
        description: "Caminamos en humildad, perdón y cooperación en el cuerpo de Cristo."
      },
      integrity: {
        title: "Integridad y transparencia",
        description: "Practicamos la honestidad, la rendición de cuentas y la buena administración."
      },
      stewardship: {
        title: "Mayordomía generosa",
        description: "Administramos tiempo, dones y recursos para la gloria de Dios."
      },
      justice: {
        title: "Justicia y misericordia",
        description: "Promovemos la dignidad de toda persona y el bien común."
      },
      multiplication: {
        title: "Multiplicación",
        description: "Impulsamos el liderazgo saludable y la plantación de iglesias."
      }
    }
  },
  quote: "¿No ardía nuestro corazón en nosotros, mientras nos hablaba en el camino, y cuando nos abría las Escrituras?",
  reference: "Lucas 24:32"
};

export const events = {
  title: "Eventos",
  subtitle: "Únete a nuestras próximas actividades y celebraciones",
  noEvents: "No hay eventos programados en este momento. ¡Mantente atento para futuras actividades!",
  items: []
};

export const sermons = {
  title: "Sermones",
  subtitle: "Predicaciones y clips de nuestros servicios",
  watchSermon: "Ver Sermón",
  items: [
    {
      title: "Predica Donde están los 9",
      pastor: "Pastor José Ramón Ruiz Pérez",
      date: "24 de agosto del 2025",
      videoUrl: "https://youtu.be/q24k49tgE7Y?si=ZE7u14Pm_5B5clk8",
      description: "Una poderosa reflexión sobre la gratitud y la importancia de reconocer las bendiciones de Dios en nuestras vidas."
    },
    {
      title: "Sermón Audio: Una Vida de Adoración",
      pastor: "Pastor José Ramón Ruiz Pérez",
      date: "13 de septiembre del 2025",
      videoUrl: "https://youtu.be/Phgh0dSAAiQ?si=hoLBLitnE9xo3jyt",
      description: "Descubriendo lo que significa vivir una vida de adoración auténtica y cómo la adoración transforma nuestra relación con Dios."
    },
    {
      title: "Mensaje La Bendición de Honrar a Padre y a Madre",
      pastor: "Pastor J",
      date: "4 de noviembre del 2024",
      videoUrl: "https://youtu.be/wottHVse_xg?si=ckiDCNqJqRov36Oq",
      description: "Un mensaje significativo sobre la importancia de honrar a nuestros padres y las bendiciones que vienen de la obediencia a los mandamientos de Dios."
    }
  ]
};

export const blog = {
  title: "Blog",
  subtitle: "Reflexiones, devocionales y enseñanzas",
  readMore: "Leer más →",
  items: [
    {
      date: "10 Dic 2024",
      title: "La Esperanza del Adviento",
      summary: "Reflexionando sobre la esperanza que encontramos en la venida de Cristo y cómo esta esperanza transforma nuestras vidas diarias en medio de las dificultades."
    },
    {
      date: "5 Dic 2024",
      title: "Viviendo en Comunidad",
      summary: "La importancia de la comunión cristiana y cómo podemos edificarnos mutuamente en la fe, siguiendo el ejemplo de la iglesia primitiva."
    },
    {
      date: "1 Dic 2024",
      title: "El Pan de Vida",
      summary: "Explorando las palabras de Jesús cuando se declaró como el Pan de Vida y lo que esto significa para nuestra relación con Él."
    }
  ]
};

export const contact = {
  title: "Contacto",
  address: "",
  email: "jrrp158@yahoo.com",
  phone: "",
  addressLabel: "Dirección",
  phoneLabel: "Teléfono",
  scheduleLabel: "Horarios de Servicio",
  comingSoon: "Información próximamente",
  imageAlt: "Entrada de iglesia acogedora",
  form: {
    title: "Envíanos un mensaje",
    name: "Nombre",
    email: "Email",
    message: "Mensaje",
    send: "Enviar Mensaje",
    sending: "Enviando...",
    namePlaceholder: "Tu nombre completo",
    emailPlaceholder: "tu@email.com",
    messagePlaceholder: "Escribe tu mensaje aquí...",
    successMessage: "¡Mensaje enviado correctamente!",
    errorMessage: "Error al enviar el mensaje. Inténtalo de nuevo."
  }
};

export const donate = {
  title: "Apoya Nuestra Misión",
  subtitle: "Tu generosidad nos ayuda a continuar compartiendo el amor de Cristo en nuestra comunidad. Cada donación hace una diferencia en las vidas que tocamos.",
  paypal: "PayPal",
  stripe: "Tarjeta",
  zelle: "Zelle"
};

export const footer = {
  copyright: "© 2025 Casa del Pan - Iglesia Evangélica. Todos los derechos reservados.",
  note: "Contenido bilingüe • Actualizado semanalmente"
};
